import { contentUpdate } from '~/app/store/content'
import { addDefaultsToRefinements } from '~/app/store/refinement/refinementTranslation'
import { LOCATION_POP } from '~/app/store/constants'
import type { GalleryModelsUrl } from 'shared/types/gallery/models'
import type { State } from 'shared/types/gallery/state'

export const stateFromQueryStateUpdate =
  (queryState: GalleryModelsUrl.QueryStringState, prevQueryString: GalleryModelsUrl.QueryStringState, isNewQVEnabled: boolean) =>
  (dispatch: State.GalleryThunkDispatch, getState: () => State.GlobalState): void => {
    if (queryState.query.qv !== prevQueryString.query.qv) {
      // Both sides non-empty means ?qv= changed from one design UUID to another — MLT Back
      // navigation driven by the @vp/quick-view-modal package. The package owns these history
      // steps; dispatching LOCATION_POP here would overwrite quickViewId with the MLT design's
      // UUID and trigger a force-close via useValidQuickViewEntity.
      // Only suppress when the new QV is active: the legacy QV also pushes ?qv=<uuid> history
      // entries during MLT navigation (via LinkWithQuery → setQuickViewId), so suppressing
      // unconditionally breaks Back navigation on the old path.
      if (isNewQVEnabled && queryState.query.qv && prevQueryString.query.qv) {
        return
      }

      dispatch({
        type: LOCATION_POP,
        payload: {
          ...queryState,
          showSpinner: false,
        },
      })

      return
    }

    const state = getState()

    dispatch(
      contentUpdate({
        actions: {
          type: LOCATION_POP,
          payload: {
            ...queryState,
            refinements: {
              ...queryState.refinements,
              attributes: addDefaultsToRefinements(queryState.refinements.attributes, state),
            },
            showSpinner: true,
          },
        },
        shouldUpdateUrl: false,
      }),
    )
  }
